<template functional>
  <div
    :class="[
      data.class,
      data.staticClass
    ]"
    class="UnderlinedHeading uppercase font-bold pb-2 mb-4 relative"
  >
    <slot/>
    <div
      :class="[`bg-${props.color}`]"
      class="UnderlinedHeading__underline absolute pin-l w-10 h-1 pin-b"
    />
  </div>
</template>

<script>
/**
 * @module UnderlinedHeading
 */
export default {
  name: 'UnderlinedHeading'
}
</script>
